import React from 'react';
import PropTypes from 'prop-types';
import RightPanel from './rightPanel';
import CenterPanel from './centerPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function ModalSetMinDurations(props) {
  return (
    <Modal show={true} hideWhenClickAway={false} className="ui modal forgot-password">
      <PopupHeader helpLink={APP.EXTERNAL_LINKS.Report.SetMinDuration} title={APP.LANGUAGE.UpdateMinDurations.Title} />
      <div className="content">
        <div className="main-ui-container pdbl">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel startDate={props.startDate} endDate={props.endDate} userId={props.userId} />
              </div>
            </div>
            <CenterPanel
              typingMinConDurationValue={props.typingMinConDurationValue}
              typingMinMeetingDurationValue={props.typingMinMeetingDurationValue}
              userId={props.userId}
            />
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel startDate={props.startDate} endDate={props.endDate} userId={props.userId} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ModalSetMinDurations.propTypes = {
  startDate: PropTypes.object, // StartDate and EndDate selected from calendar for reporting
  endDate: PropTypes.object,
};
